import { Modal } from "react-bootstrap";
import "../index.css";
import { useGlobalContext } from "./context/globalContext";

const Modal1 = () => {
  //   const [showModal1, setShowModal1] = useState(false);
  const { showModal1, handleCloseModal1 } = useGlobalContext();

  return (
    <Modal
      className="offer-modal"
      show={showModal1}
      onHide={handleCloseModal1}
      centered
    >
      {/* <Modal.Header className="offer-modal-head">
        <ModalTitle
          className="text-center offer-modal-title"
          
        >
          
        </ModalTitle>
      </Modal.Header> */}
      <Modal.Body>
        <div className="offerr" style={{}}>
          <img
            src="images/closeSvg.svg"
            alt=""
            style={{
              height: "1.5rem",
              width: "1.5rem",
              position: "absolute",
              background: "#9d9d9d",
              //   top: window.innerWidth > 768 ? "1.2rem" : ".75rem",
              left: ".2rem",
              cursor: "pointer",
            }}
            onClick={handleCloseModal1}
          />
          <img
            src="images/offer-image.jpeg"
            alt=""
            style={{
              maxWidth: "100%",
              height: "100%",
              objectFit: "contain", // or "cover" if you prefer
            }}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default Modal1;
